import React, { useContext } from 'react';
import { AssignmentFeedbackForm } from 'domains/assignments/Components/AssignmentFeedbackForm';
import { structuredActivityStepId } from 'domains/structuredActivities/steps';
import {
  CustomStructuredActivityCtx,
  withCustomStructuredActivityContext,
} from 'domains/customStructuredActivities/context';

const SubmitActivity: React.FC = () => {
  const { onComplete, previewMode } = useContext(CustomStructuredActivityCtx);

  return <AssignmentFeedbackForm onSubmit={onComplete} previewMode={previewMode} />;
};

export default withCustomStructuredActivityContext(SubmitActivity, structuredActivityStepId.submitActivity);
